import React from 'react'
import { Card, Button } from '@design-system-coopeuch/web';
import PropTypes from 'prop-types';

import cedulaVieja from '../../../assets/img/icon/cedula-vieja.svg';
import cedulaNueva from '../../../assets/img/icon/cedula-nueva.svg';

import { properties } from '../../../../utils/properties'
import { WrapperModal } from './styles';

const Modal = ({ closeModal }) => {
  return (
    <WrapperModal>
      <div className="modal">
        <div className="modalContent">
          <Card>
            <div className="btnModal">
              <p className="btnModal__title">
                {properties.pasos.paso1.verificacion.dialogo.titulo}
              </p>
              <Button
                className="btnModal__btn"
                variant="text"
                suffix="old-line-cross"
                onClick={() => closeModal()}
              />
            </div>
            <div className="imgContent">
              <div className="imgContent__first">
                <p>Cédula Nueva</p>
                <img src={cedulaNueva} alt="usuario TC" />
              </div>
              <div className="imgContent__last">
                <p>Cédula Antigua</p>
                <img src={cedulaVieja} alt="usuario TC" />
              </div>
            </div>
            <div className="btnFooter">
              <Button className="btnFooter__btn" color="secondary" onClick={() => closeModal()}>
                Entendido
              </Button>
            </div>
          </Card>
        </div>
      </div>
    </WrapperModal>
  );
}
Modal.propTypes = {
  closeModal: PropTypes.func
};
Modal.defaultProps = {
  closeModal: () => { }
};
export default Modal